import { SelectVariant } from '@kijiji/ui'
import { useDecision } from '@optimizely/react-sdk'
import dynamic from 'next/dynamic'

import { SrpResults } from '@/components/srp/results-sort/results'
import { SrpResultsSortContainer, SrpSortContainer } from '@/components/srp/results-sort/styled'
import { FEATURE_FLAG } from '@/lib/optimizely'

const SrpSort = dynamic(() => import('./sort').then((mod) => mod.SrpSort), { ssr: false })

export const SrpResultsSort = () => {
  const [srpQuickFilterPillsDecision] = useDecision(FEATURE_FLAG.SRP_QUICK_FILTERS_PILLS)
  const areQuickFilterPillsActive = srpQuickFilterPillsDecision?.enabled

  return (
    <SrpResultsSortContainer>
      <SrpResults showOnLargeBreakpoint />

      <SrpSortContainer isRoundedSelect={areQuickFilterPillsActive}>
        <SrpSort
          variant={areQuickFilterPillsActive ? SelectVariant.ROUNDED : SelectVariant.DEFAULT}
        />
      </SrpSortContainer>
    </SrpResultsSortContainer>
  )
}
